<div class="modal-container page-content property">
  <div class="modal-header">
    <h5 class="modal-heading">{{isEditMode ? 'Edit' : 'Add'}} Room</h5>
    <p class="modal-clost-btn" (click)="bsModalRef.hide()" aria-label="Close">&times;</p>
  </div>

  <div class="modal-body" *ngIf="isEditMode&&roomDetails|| (!isEditMode); else pageLoader">
    <div class="tab-primary">
      <tabset>
        <tab [active]="activeTab==''" [disabled]="!isEditMode && enableTab" heading="General" id="tab1">
          <div class="form-section visible my-3">
            <!-- <h4>Let’s know the bills for this property</h4> -->
            <label class="form-label mt-2">Give this room a Title <span class="text-danger">*</span> </label>
            <app-input [formGrp]="form" formCtrlName="display_name" text [label]="'Enter a suitable title'"></app-input>
            <div class="form-input mb-2">
              <label class="form-label">Available Date <span class="text-danger">*</span> </label>
              <app-input formCtrlName="available_from" [formGrp]="form" date [required]="true"></app-input>
            </div>
          </div>
          <div class="modal-foot">
            <div class="d-flex justify-content-end align-items-center">
              <div>
                <app-button [disabled]="!genNextBtnState || loading" (onclick)="handleNext('general','rent')"
                  primary>
                  {{ loading ? 'Saving...' : 'Next'}}
                </app-button>
              </div>
            </div>
          </div>
        </tab>
        <tab [active]="activeTab=='rent'" [disabled]="!isEditMode && enableTab" heading="Rent">
          <div class="form-section visible pb-0 m-0">

            <label class="form-label">Rent Tenure</label>
            <app-select-list formCtrlName="cycle" [formGrp]="rentForm" [options]="rentCycles"></app-select-list>

            <label class="form-label">Rent Amount (£) <span class="text-danger">*</span> </label>
            <app-input formCtrlName="amount" [formGrp]="rentForm" inputNumber label="Enter rent amount">
            </app-input>

            <label class="form-label">Security Deposit (£)</label>
            <app-input formCtrlName="security_deposit" [formGrp]="rentForm" inputNumber label="Enter security deposit">
            </app-input>

            <label class="form-label">Holding Deposit (£)</label>
            <app-input formCtrlName="holding_deposit" [formGrp]="rentForm" inputNumber label="Enter holding deposit">
            </app-input>
            <div class="">
              <app-input-list-group formCtrlName="bills_included" [formGrp]="rentForm" [formData]="billsFormData">
              </app-input-list-group>
            </div>
      
            <div class="modal-foot ">
              <div class="d-flex justify-content-end align-items-center">
                <div>
                  <app-button [disabled]="!isRentValid || loading" (onclick)="handleNext('rent','photos')"
                    primary>
                    {{ loading ? 'Saving...' : 'Next'}}
                  </app-button>
                </div>
              </div>
            </div>
          </div>
        </tab>
        <tab [active]="activeTab=='photos'" [disabled]="!isEditMode && enableTab" heading="Photos">
          <div class="mt-3">
            <app-add-room-photos-modal #photoComp [propertyDetails]="propertyDetails" [roomId]="roomId">
            </app-add-room-photos-modal>
          </div>
          <div class="modal-foot border-top pt-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <a (click)="toggleTab('rent')">Back</a>
              </div>
              <div>
                <app-button [disabled]="(photoComp.uploadingState||!isDisNameValid) || loading"
                  (onclick)="handleNext('photos','description')" primary>Next</app-button>
              </div>
            </div>
          </div>
        </tab>
        <tab [active]="activeTab=='description'" [disabled]="!isEditMode && enableTab" heading="Description">
          <div class="alert alert-info mt-3" role="alert">
            <p><span>
              We have generated a very clean description for your property. Below, you can find the fields used in generating your description.
            </span>
          </p>
          </div>
          <form [formGroup]='form'>
            <div class="form-input">
              <textarea formControlName="description" class="form-control" style="height: 220px !important;"></textarea>
            </div>
            <div class="mt-2 mb-2">
              <p class="text-muted">Maximum characters: 500</p>
            </div>
          </form>
          <div class="modal-foot border-top pt-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <a (click)="toggleTab('photos')">Back</a>
              </div>
              <div>
                <app-button [disabled]="!(isDescValid&&isDisNameValid) || loading"
                  (onclick)="handleNext('description','finish')" primary>
                  {{ loading ? 'Saving...' : 'Finish'}}
                </app-button>
              </div>
            </div>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
  <ng-template #pageLoader>
    <div class="modal-body text-center">
      <app-loader></app-loader>
    </div>
  </ng-template>
</div>
